import { Component } from '@angular/core';
import { NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';
import { ApplicationService } from '../../services/application.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule, NgIf],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {

  constructor(private authenticationService:AuthenticationService, private router:Router, private applicationService:ApplicationService) {}

  loginData = {
    username: '',
    password: ''
  };

  showInvalidLoginMessage = false;

  async onSubmit() {
    this.showInvalidLoginMessage = false;
    this.applicationService.showGlobalSpinner();
    let isSuccess = await this.authenticationService.login(this.loginData.username, this.loginData.password);
      this.applicationService.hideGlobalSpinner();
    if(isSuccess)
      this.router.navigate(['/sessions']);
    else
      this.showInvalidLoginMessage = true;
  }
}
